module.exports = __webpack_public_path__ + "static/media/loxone-history-2-mobile.33218507.png";